import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import LandingBanners from '@/components/home/LandingBanners';
import { CategoryShowcase } from '@/components/home/CategoryShowcase';
import { FlashDeals } from '@/components/home/FlashDeals';
import { TrendingProducts } from '@/components/home/TrendingProducts';
import { NewArrivals } from '@/components/home/NewArrivals';
import { HomeStats } from '@/components/home/HomeStats';
import { WhyChooseUs } from '@/components/home/WhyChooseUs';
import { AppDownloadBanner } from '@/components/home/AppDownloadBanner';
import { Testimonials } from '@/components/home/Testimonials';

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      
      <section className="container mx-auto px-4 py-8 md:py-12">
        <LandingBanners />
      </section>

      <CategoryShowcase />
      {/* <FlashDeals /> */}
      <TrendingProducts />
      <NewArrivals />
      <HomeStats />
      <AppDownloadBanner />
      <WhyChooseUs />
      <Testimonials />
    </Layout>
  );
};

export default Index;